// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 26 ? "4b5b508e" : chunkId) + "." + {"26":"6732273bfed675e5","2252":"ad096801137fb7a5","6970":"5618228b3c81e7de","9408":"e57178498367fb61"}[chunkId] + ".js";
};